import React from "react"
import { Modal } from "react-bootstrap"
import { IcOtpCall, IcOtpMessage } from "../common/svg";


export default class VerifyPhoneOptBreak extends React.Component {
    
    closeForm = () => {
        this.props.hideModal();
    }

    render() {


        return <Modal
            show={this.props.show}
            onHide={this.closeForm}
            dialogClassName="modal-s modal-dialog modal-confirm">

            <Modal.Header closeButton={true} closeLabel={""}>
                <h5>THÔNG BÁO</h5>
            </Modal.Header>
            
            <Modal.Body>
                <div className="modal-confirm-body otp-body">
                    <p className="font-14">Bạn không nhận được OTP? Liên hệ ngay với Mioto để được hỗ trợ.</p>
                    <div className="wrap-btn db-btn">
                        <a className="btn btn--s btn-secondary" href="tel:19009217"><div className="wrap-svg"><IcOtpCall /></div><span>Gọi</span></a>
                        <a className="btn btn--s btn-secondary" target="_blank" href="https://www.messenger.com/t/mioto.vn">
                            <div className="wrap-svg">
                                <IcOtpMessage />
                            </div>
                            <span>Nhắn tin</span>
                        </a>
                    </div>
                </div>
            </Modal.Body>
        </Modal >
    }
}